import React from 'react';
import axios from 'axios';
import { LatestPosts } from '../../server/src/db';

export const baseStyle: React.CSSProperties = {
  margin: '1%',
  display: 'flex',
  flexDirection: 'column',
  background: 'linear-gradient(176deg, #DED4B3, 3%, #F5F2E8, 94%, #DED4B3)',
  textAlign: 'center',
  position: 'relative',
};

const TITLE = "Builder's Posts";
const FOLIO = 'Updates, Events, and Deck Lists';

interface FrontPostProp {
  server: string;
  isEditor?: boolean;
}

export function parseLogBody(body: string): string {
  const titlePos = body.indexOf('#');
  const endOfTitle = body.indexOf('\n', titlePos);

  const frontPost = titlePos !== -1 && titlePos <= 1 ? body.slice(endOfTitle) : body;
  return frontPost.length > 200
    ? frontPost.slice(0, 200).trim() + '... ... Click to continue reading'
    : frontPost;
}

export function parseUpdateBody(body: string): string {
  const titlePos = body.indexOf('#');
  const endOfTitle = body.indexOf('\n', titlePos);

  const nextHeader = body.indexOf('#', endOfTitle);
  const endOfTitleBody = nextHeader !== -1 ? nextHeader : undefined;

  const frontPost = body.slice(endOfTitle);
  const frontPostBody = body.slice(endOfTitle, endOfTitleBody);
  return frontPost.length > 300
    ? frontPostBody.slice(0, 300).trim() + '... ... Click to continue reading'
    : frontPostBody;
}

export function ITCGFrontPost(props: FrontPostProp) {
  const [width, setWidth] = React.useState(window.innerWidth);
  const [posts, setPosts] = React.useState<LatestPosts>();
  const breakpoint = 899;

  React.useEffect(() => {
    (async () => {
      const resp = await axios('/posts', {
        baseURL: props.server,
        timeout: 5000,
      });
      if (!resp.data) return;

      setPosts(resp.data);
    })();

    const handleResizeWindow = () => setWidth(window.innerWidth);
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener('resize', handleResizeWindow);

    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener('resize', handleResizeWindow);
    };
  }, []);

  const updatePostDate = !!posts?.update[0]?.created_at
    ? new Date(posts.update[0].created_at)
    : new Date();

  const update = (
    <>
      {posts?.update[0] && (
        <a className="text-primary" href={`/posts/${posts.update[0].id}`}>
          <h2>{posts.update[0].title}</h2>
          <p className="padding">{parseUpdateBody(posts.update[0].body)}</p>
        </a>
      )}
      <a className="paper-btn margin-top margin-bottom" href={'/posts/update'}>
        Previous Updates
      </a>
    </>
  );

  const decklist = (
    <>
      <h3>Daily Deck Lists</h3>
      <div className="row">
        <div className="lg-4">
          <div className="margin-left margin-right">
            {posts?.list.latest && (
              <a href={`/posts/${posts.list.latest.id}`}>
                <div className="card border">
                  <div className="card-body">
                    <h4 className="card-title">Latest</h4>
                    <h4 className="card-subtitle">
                      <b>{posts.list.latest.title}</b>
                    </h4>
                    <p className="card-text">{`by ${posts.list.latest.owner.username}`}</p>
                  </div>
                </div>
              </a>
            )}
          </div>
        </div>
        <div className="lg-4">
          <div className="margin-left margin-right">
            {posts?.list.famous && (
              <a href={`/posts/${posts.list.famous.id}`}>
                <div className="card border">
                  <div className="card-body">
                    <h4 className="card-title">Famous</h4>
                    <h4 className="card-subtitle">
                      <b>{posts.list.famous.title}</b>
                    </h4>
                    <p className="card-text">{`by ${posts.list.famous.owner.username}`}</p>
                  </div>
                </div>
              </a>
            )}
          </div>
        </div>
        <div className="lg-4">
          <div className="margin-left margin-right">
            {posts?.list.random && (
              <a href={`/posts/${posts.list.random.id}`}>
                <div className="card border">
                  <div className="card-body">
                    <h4 className="card-title">Random</h4>
                    <h4 className="card-subtitle">
                      <b>{posts.list.random.title}</b>
                    </h4>
                    <p className="card-text">{`by ${posts.list.random.owner.username}`}</p>
                  </div>
                </div>
              </a>
            )}
          </div>
        </div>
      </div>
      <a className="paper-btn margin-top" href={'/posts/list'}>
        See All
      </a>
    </>
  );

  const log = (
    <>
      <h3 className="card-title">Dev Logs</h3>
      {posts?.log &&
        posts.log.map((post) => {
          return (
            <a className="text-primary" href={`/posts/${post.id}`}>
              <p className="padding">
                <span className="badge">{new Date(post.created_at).toDateString()}</span>{' '}
                {parseLogBody(post.body)}
              </p>
            </a>
          );
        })}
      <hr />
      <p className="padding">Peruse historical developer updates in the Log Book</p>
      <a className="paper-btn" href={'/posts/log'}>
        Log Book
      </a>
    </>
  );

  const event = (
    <>
      {!props.isEditor && (
        <>
          <h3>Events</h3>
          <p className="padding">
            Placeholder for potential future events and event reports
          </p>
          <p className="padding">Join the Discord to show interest!</p>
        </>
      )}
      {props.isEditor && (
        <>
          <h3>Editor</h3>
          <a className="paper-btn" href="/posts/write">
            Write Post
          </a>
        </>
      )}
    </>
  );

  const newspaper = (
    <div className="border shadow shadow-hover padding" style={baseStyle}>
      <h1 className="margin-bottom" style={{ fontWeight: 'bolder' }}>
        {TITLE}
      </h1>
      <div
        className="row margin-none"
        style={{ backgroundColor: 'grey', color: 'white' }}
      >
        <p className="col-2 margin-none">Front Page</p>
        <p className="col-8 margin-none">{FOLIO}</p>
        <p className="col-2 margin-none">
          {updatePostDate.toLocaleDateString(undefined, {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          })}
        </p>
      </div>
      <div className="row" style={{ position: 'relative' }}>
        {' '}
        <div className="col-3">{log}</div>
        <div className="col-9 row" style={{ position: 'relative' }}>
          <div
            style={{
              borderLeft: 'solid grey',
              position: 'absolute',
              top: '10%',
              bottom: '2%',
            }}
          ></div>
          <div className="col-12" style={{ position: 'relative' }}>
            {update}
            <div
              style={{
                borderBottom: 'solid grey',
                position: 'absolute',
                left: '15%',
                right: '15%',
              }}
            ></div>
          </div>
          <div className="col-9">{decklist}</div>
          <div className="col-3" style={{ position: 'relative' }}>
            <div
              style={{
                borderRight: 'solid grey',
                position: 'absolute',
                top: '15%',
                bottom: '15%',
              }}
            ></div>
            {event}
          </div>
        </div>
      </div>
    </div>
  );

  if (width > breakpoint) {
    return newspaper;
  } else {
    return (
      <div style={baseStyle} className="border shadow">
        <h1>{TITLE}</h1>
        <h4>{FOLIO}</h4>
        {updatePostDate.toLocaleDateString(undefined, {
          month: 'long',
          day: 'numeric',
          year: 'numeric',
        })}
        <div className="child-borders flex">
          <div className="col margin padding-none">{update}</div>
          <div className="col margin padding-none">{decklist}</div>
          <div className="col margin padding-none">{log}</div>
          <div className="col margin padding-none">{event}</div>
        </div>
      </div>
    );
  }
}
